import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { Route } from 'react-router-dom/cjs/react-router-dom'

import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import { fetchAlerts } from '../AlertsActions'

import Filter from './Filter'
import List from './List'
import CreateEdit from './create-edit'

const Alerts = () => {
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    rows: 10,
    page: 1,
    title: '',
    dispatched: '',
  })

  useEffect(() => {
    dispatch(fetchAlerts(form))
  }, [form])

  return (
    <>
      <BaseCreatePage page="Alertas" path="Alertas" pageLink="/alerts" hiddenReturn>
        <Grid container spacing={3} style={{ marginTop: '1em' }}>
          <Grid item xs={12}>
            <Filter form={form} setForm={setForm} />
          </Grid>
          <Grid item xs={12}>
            <List form={form} setForm={setForm} />
          </Grid>
        </Grid>
      </BaseCreatePage>

      <Route path="/alerts/create-edit/:id" component={CreateEdit} />
    </>
  )
}

export default Alerts
